import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Button, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import { CPDPrelanding, CPDSuccessScreen, CPDAsideTrap } from 'shared/components/CPD';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { ICPDPrelandingConfig } from 'shared/containers/valuationTraps/HomeownerTrap/CPDHomeownerTrap/types';
import { useCPDProps } from 'shared/containers/valuationTraps/hook/useCPDProps';
import { useCpdTracking } from 'shared/containers/valuationTraps/utils/tracking/cpd';
import { ECpdDraftStatus } from 'shared/types/cpd/cpd';

export const CPDAsideTrapContainer: React.FC = () => {
  const {
    cpdDraftStatus,
    cpdDraftId,
    offer,
    isModalOpen,
    phoneValue,
    onPhoneInputChange,
    onTrapClick,
    onGoCianChat,
    onCloseTrapModal,
    onCreateDraftCpd,
    isUserAuthorized,
    isMarketingAgreement,
    handleChangeMarketingAgreement,
  } = useCPDProps();
  const { trackCPDTrapVisible } = useCpdTracking();

  const { config } = useApplicationContext();
  const prelandingContent = config.get<ICPDPrelandingConfig>('CPDPrelandingData');

  if (!prelandingContent?.searcher) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackCPDTrapVisible} callbackDelay={1000}>
      <>
        <CPDAsideTrap onClick={onTrapClick} />
        <ModalWindow
          header={<div />}
          open={isModalOpen}
          onClose={onCloseTrapModal}
          content={
            cpdDraftStatus === ECpdDraftStatus.success ? (
              <CPDSuccessScreen
                cpdDraftId={cpdDraftId}
                successButton={
                  isUserAuthorized ? (
                    <Button onClick={() => onGoCianChat(cpdDraftId)} theme="fill_primary">
                      Подробности — в чате Циан
                    </Button>
                  ) : (
                    <Button onClick={onCloseTrapModal} theme="fill_primary">
                      Буду ждать
                    </Button>
                  )
                }
              />
            ) : (
              <CPDPrelanding
                cpdDraftStatus={cpdDraftStatus}
                onCreateDraftCpd={onCreateDraftCpd}
                prelandingContent={prelandingContent.searcher}
                phoneValue={phoneValue}
                onInputChange={onPhoneInputChange}
                withInput
                isMarketingAgreement={isMarketingAgreement}
                handleChangeMarketingAgreement={handleChangeMarketingAgreement}
                cpdLandingLink={
                  prelandingContent.searcher.secondaryBtn &&
                  `${prelandingContent.searcher.secondaryBtn.url}?cian_source=trapOfferScreenPriceBlock_web&offerCategory=${offer.category}`
                }
              />
            )
          }
          size="XS"
          width={540}
        />
      </>
    </ActionAfterViewObserver>
  );
};
